import { P0, S, abs, arc, disc, max, moodK } from '../../geometry';

export const halo = {
  name: 'Halo',
  colors: ['#3E63DD', '#E3A008'],
  draw(m, t) {
    let r = 30 + 0.6 * S(t * 1.6),
      g = 70,
      spin = 8 * S(t * 0.6),
      ispin = -20 * S(t * 0.6),
      ir = 21,
      ispan = 50,
      pose = P0();
    if (m === 'happy') {
      r = 30 + 2.5 * abs(S(t * 7));
      g = 120 + 15 * S(t * 8);
      spin = 0;
      ispin = 25 * S(t * 6);
      pose.ty = -2 * abs(S(t * 6));
    }
    // Thinking: the gap in the ring keeps circling, the inner arc the other way.
    if (m === 'thinking') {
      spin = t * 160;
      ispin = -t * 230;
    }
    if (m === 'talking') {
      g = 40 + 60 * max(0, S(t * 10));
      spin = 0;
      ispin = 10 * S(t * 5);
    }
    if (m === 'surprised') {
      r = 36;
      g = 24;
      spin = 1.5 * S(t * 28);
      ispan = 30;
    }
    if (m === 'paused') {
      r = 27;
      g = 170;
      spin = 2 * S(t * 0.5);
      ispan = 20;
      ir = 19;
    }
    return {
      strokes: [
        {
          c: 'a',
          pts: arc(50, 52, r, 90 + g / 2, 450 - g / 2, 20),
          n: 24,
          spin,
        },
        {
          c: 'b',
          pts: arc(50, 52, ir, -90 - ispan / 2, -90 + ispan / 2, 6),
          spin: ispin,
        },
      ],
      eyes: { x: 50, y: 52 },
      pose,
    };
  },
  eyesOn: 'a',
  solid(f, m, t) {
    const arcPts = f.strokes[1].pts,
      r0 = Math.hypot(arcPts[0][0] - 50, arcPts[0][1] - 52),
      k = 24.5 / r0;
    f.strokes[1] = {
      ...f.strokes[1],
      pts: arcPts.map(([x, y]) => [50 + (x - 50) * k, 52 + (y - 52) * k]),
    };
    f.strokes.unshift({
      c: 'a',
      fill: true,
      pts: disc(50, 52, 14.5 * moodK(m, t)),
      n: 24,
    });
    return f;
  },
};
